import ReactGA, { InitializeOptions } from 'react-ga';
import type { UserWithMetadata } from '@gamiphy/gamix-modules/user/types';

type Product = {
  id: string;
  name?: string;
  category?: string;
  brand?: string;
  variant?: string;
  price?: string;
}

export abstract class GA {
  private static trackingId?: string;

  private static trackerName?: string;

  private static get trackerNames(): string[] {
    return this.trackerName ? [this.trackerName] : [];
  }

  private static get ecPlugin(): string {
    return this.trackerName ? `${this.trackerName}.ec` : 'ec';
  }

  public static initialize(appId: string, trackingId: string, trackerName?: string, options?: InitializeOptions): void {
    this.trackingId = trackingId;
    this.trackerName = trackerName;

    ReactGA.initialize([{
      trackingId: this.trackingId,
      gaOptions: { name: this.trackerName },
      titleCase: false,
    }], {
      alwaysSendToDefaultTracker: false,
      ...options,
    });
    ReactGA.set({
      hostname: `${appId}.gamiphy.co`,
    }, this.trackerNames);
    ReactGA.plugin.require('ec', undefined, this.trackerName);
  }

  public static setUser(user: UserWithMetadata): void {
    ReactGA.set({
      userId: user.id,
      dimension1: user.id,
      dimension2: user.type,
    }, this.trackerNames);
  }

  public static trackEvent(category: string, action: string, label?: string, value?: number): void {
    ReactGA.event({
      category,
      action,
      label,
      value,
    }, this.trackerNames);
  }

  public static pageView(page: string): void {
    ReactGA.pageview(page, this.trackerNames);
  }

  public static productPageView(product: Product): void {
    ReactGA.plugin.execute(this.ecPlugin, 'addProduct', product);
    ReactGA.plugin.execute(this.ecPlugin, 'setAction', 'detail');
    ReactGA.ga(this.trackerName ? `${this.trackerName}.send` : 'send', 'pageview');
  }

  public static modelView(name: string): void {
    ReactGA.pageview(name, this.trackerNames);
  }
}
